import request from '../servises/blogRequest'

export function getAuthors(params) {
    if(params) {
        params = `?${params}`
    } else {
        params = ''
    }

    return request({
        url: `authors/${params}`,
        method: 'GET'
    })
}
export function deleteAuthor(params) {
    return request({
        url: `authors/${params}`,
        method: 'DELETE'
    })
}

export function getShowAuthor(params) {
    return request({
        url: `authors/${params}`,
        method: 'GET'
    })
}

export function updateAuthor(params) {
    params.formData.append('_method','PUT')

    return request({
        url: `authors/${params.id}`,
        method: 'POST',
        data: params.formData
    })
}

export function createAuthor(params) {

    return request({
        url: `authors`,
        method: 'POST',
        data: params
    })
}

export function getSocialNetworks() {
    return request({
        url: `social-networks`,
        method: 'GET'
    })
}
